<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-10 15:56:07
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-16 10:34:39
-->
<template>
  <div class="MonthSelect">
    <van-datetime-picker
      v-model="currentDate"
      type="year-month"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onConfirm"
      :formatter="formatter"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'MonthSelect',
  data() {
    return {
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
    };
  },
  mounted() {
    const resultDate = new Date(
      new Date().getTime() - 365 * 2 * 24 * 3600 * 1000,
    );
    const month = resultDate.getMonth() + 1;
    const year = resultDate.getFullYear();
    this.minDate = new Date(year, month);
  },
  props: ['date'],
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}`;
      } if (type === 'month') {
        return `${val}`;
      }
      return val;
    },
    onConfirm(val) {
      this.$emit('getVal', {
        tranType: '',
        month: moment(val).format('YYYY.MM'),
        endDate: '',
        status: '1',
      });
    },
  },
};
</script>
<style scoped>
.MonthSelect >>>.van-picker__mask{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-image: -webkit-linear-gradient(top,rgba(255,255,255,.9),rgba(255,255,255,.4)),-webkit-linear-gradient(bottom,rgba(255,255,255,.9),rgba(255,255,255,.4));
    background-image: linear-gradient(180deg,rgba(255,255,255,.9),rgba(255,255,255,.4)),linear-gradient(0deg,rgba(255,255,255,.9),rgba(255,255,255,.4));
    background-repeat: no-repeat;
    background-position: top,bottom;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    pointer-events: none;
}
.MonthSelect >>>.van-picker__cancel{
  display: none;
}
.MonthSelect >>>.van-picker__toolbar{
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
}
.MonthSelect >>>.van-picker__columns{
  margin-top: 50px;
}
.MonthSelect >>>.van-picker__confirm{
  width: 80%;
  background: olive;
  margin: 0 auto;
  background-image: linear-gradient(180deg, #F5514A 2%, #F5683C 99%);
  border-radius: 8px;
  color: #fff;
}
</style>
